<template>
  <div id="paperContainer">
    <div class="containers">
      <a-space>
        <slot></slot>
      </a-space>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
#paperContainer {
  width: 100%;
  margin: 0;

  .containers {
    width: 70%;
    // height: 100%;
    margin: auto;
    font-size: 1vw;

    // font-size: var(--el-menu-item-font-size);
    // padding: 30px 10px;
    // border: 1px solid aqua;
    /* 移动端强制占满宽度 */
    @media (max-width: 768px) {
      width: 95% !important;
      margin: 0 !important;
      padding: 0 !important; // 可选：清除内边距
    }
  }
}
</style>